import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';
import { down } from 'styled-breakpoints';

export const Overlay = styled(motion.div)`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
`;

type ModalContainerProps = {
  $width: string;
};

export const ModalContainer = styled(motion.div)<ModalContainerProps>`
  ${({ theme, $width }) => css`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: ${$width};
    max-width: 100%;
    background: ${theme.colors.background[100]};
    z-index: 101;
    display: flex;
    flex-direction: column;
    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);

    ${down('md')} {
      width: 100%;
    }
  `}
`;

export const Header = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1.25rem;
    border-bottom: 1px solid ${theme.colors.background[80]};
    flex-shrink: 0;
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    margin: 0;
    font-size: 1.125rem;
    font-weight: 600;
    color: ${theme.colors.foreground[100]};
  `}
`;

export const CloseButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    border: none;
    background: transparent;
    color: ${theme.colors.foreground[60]};
    border-radius: 0.5rem;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: ${theme.colors.background[80]};
      color: ${theme.colors.foreground[100]};
    }
  `}
`;

export const Content = styled.div`
  ${({ theme }) => css`
    flex: 1;
    overflow-y: auto;
    padding: 1.25rem;
    color: ${theme.colors.foreground[100]};
  `}
`;
